import { render, staticRenderFns } from "./weixin.vue?vue&type=template&id=2becf071&scoped=true"
import script from "./weixin.vue?vue&type=script&lang=js"
export * from "./weixin.vue?vue&type=script&lang=js"
import style0 from "./weixin.vue?vue&type=style&index=0&id=2becf071&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2becf071",
  null
  
)

export default component.exports